import { render, staticRenderFns } from "./createFloorSpace.vue?vue&type=template&id=e535c70a"
import script from "./createFloorSpace.vue?vue&type=script&lang=js"
export * from "./createFloorSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports